"use strict";

var _Box;
import { Box, ProgressSpinner } from '@autoguru/overdrive';
import { jsx as _jsx } from "react/jsx-runtime";
export const AsyncFallback = () => _Box || (_Box = /*#__PURE__*/_jsx(Box
// biome-ignore lint/a11y/useSemanticElements: migration quick fix. To be fixed when code is touched
, {
  role: "status",
  width: "full",
  paddingX: "5",
  paddingY: "3",
  display: "flex",
  justifyContent: "center",
  children: /*#__PURE__*/_jsx(ProgressSpinner, {
    size: "medium",
    colour: "secondary"
  })
}));